import { connect } from 'react-redux'
import $CACHE from '../../helpers/cache'
import { formatHistoryLiveData } from '../../services/lotteryService.jsx'

// 引入公共组件
import ALERT from '../../components/modal/Alert.jsx';
import CONFIRM from '../../components/modal/confirm.jsx';
import OVERLAY from '../../components/overlay/Overlay.jsx';
import LOADING from '../../components/overlay/OverlayLoading.jsx';
import SUPER_AUDIO from '../../components/media/AudioPlus.jsx'
import DRAG_FRAME from '../../components/container/DragFrame.jsx'
import TOAST from '../../components/modal/Toast.jsx'
import Popup from '../../components/modal/popup.jsx'
import PrizeTips from '../../components/modal/PrizeTips.jsx';
import TransferMoney from '../../components/modal/TransferMoney.jsx'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { DOMAIN } from '../../constants/config';

class Framework extends React.Component {

  constructor(props) {
    super(props);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.handleCloseConfirm = this.handleCloseConfirm.bind(this);
    this.handleEnterConfirm = this.handleEnterConfirm.bind(this);
    this.handleMessages = this.handleMessages.bind(this);
    this.handleCloseDragFrame = this.handleCloseDragFrame.bind(this);
    this.stopSound = this.stopSound.bind(this);
    this.closeToast = this.closeToast.bind(this);
    this.toggleFrameModalByMessage = this.toggleFrameModalByMessage.bind(this);
    // this.handleRechargeClick = this.handleRechargeClick.bind(this);
    this.state = {
      showPrizeTips: false,//是否显示中奖提示窗口
      frameState: 'select'
    }
	  
  }

  // 手机版切换
  componentWillMount(){
    // $.setCookie('stay_status', 'PC', 300)
    const MOBILE_REX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const stay_status = $.getCookie('stay_status');
    if (MOBILE_REX.test(navigator.userAgent) && stay_status !== 'PC' && window.vers !== 'df') {
      $.delCookie('stay_status');
      window.stopRender = true;
      return window.location.href = "/webapp/#/";
    }
  }

  // 框架进入
  componentDidMount() {
    this.toggleVers();
    if (window.stopRender) {
      return;
    }
    //广告合集
    this.props.$$BASE.getAds();
    // 获取动态配置，版本号等
    this.props.$$COMMON.getWebContext();
    // 监听IFRAME事件出发
    window.addEventListener('message', this.toggleFrameModalByMessage, false)
    // 用户是否登录超时
    if (!_.includes(window.location.href, '#/login')) {
      // COOKIE 拿上次老版登录session
      var sess = $.getCookie('_sessionHandler');
      var user = $.getCookie('u');
      // 以前没有登录，或者COOKIE已经过期
      if (!(sess && user) && !window.AUTH_TOKEN) {
        this.props.$$USER.logout();
        this.props.$$BASE.showUI(0.3);      
        return;
      }
      this.props.$$USER.getUserInfo();
    }else{
      this.props.$$BASE.showUI();      
    }
    if (!!window.ActiveXObject || "ActiveXObject" in window){
      window.isIE = true
    }else{
      window.isIE = false
    }
  }

  // 推送开启
  componentWillReceiveProps(nextProps) {
    const push = this.props.__PUSH.toJS();
    const __push = nextProps.__PUSH.toJS();
    const base = this.props.__BASE.toJS();
    const __base = nextProps.__BASE.toJS();
    const __common = nextProps.__COMMON.toJS();
	
    
    let isMaskDisplay = __base.modal.overlay.display || __base.modal.iframe.display;
    //初始化 this.oldDisplay 为false
    if(this.oldDisplay == null ||this.oldDisplay == undefined) {this.oldDisplay = false}
	  //监听 是否打开遮罩层，状态一致不再重复设置
	  if(isMaskDisplay !== this.oldDisplay){
		  this.oldDisplay =  isMaskDisplay ;
		  if(isMaskDisplay ) {
			  $.disableScroll();
		  }else {
        this.setState({
          frameState: 'select'
        })
			  $.enableScroll()
		  }
	  }
    
    // 设置环境变量
    if (!base.ui.display && __base.ui.display) {
      // 玩法异步加载
      if ($CACHE.get('method_static')) {
        this.props.$$LOTTERY.initLotteryMethods($CACHE.get('method_static').data);
      } else {
        require.ensure([], function () {
          const methods = require("../../constants/lotterys/methods").METHODS;
          $CACHE.put('method_static', methods, 30);
          this.props.$$LOTTERY.initLotteryMethods(methods);
        }.bind(this))
      }
    }

    // 开启推送
    if (__push.server_info && __push.push_status && !push.push_status) {
      const { push_service_status, pub_channel_token, push_server_host, pub_channel_id, user_channel_id } = __push.server_info;

      // 推送对象
      this.pushService = $.getPushStream(location.host, push_service_status, pub_channel_token);
      // 推送服务器关闭
      if (!_.isObject(this.pushService)) { return; }
      // 开启推送
      this.pushService.disconnect();
      this.pushService.onmessage = this.handleMessages;
      this.pushService.onerror = this.handlePushError;
      this.pushService.addChannel(pub_channel_id);
      this.pushService.addChannel(user_channel_id);
      this.pushService.connect();
    }

    // 关闭推送
    if (push.push_status && !__push.push_status && this.pushService) {
      this.pushService.disconnect();
      window.PushStreamManager = [];
    }
  }

  //极速充提订单确认
  handleOrderConfirm = (data) => {
    if(data.received && data.type==='bank'){
      return this.props.$$BASE.openAlert('系统已为您匹配到收款账户, 请到"极速充值订单"查看, 谢谢!');
    }
    if (data.unconfirm) {
      this.props.$$BASE.openConfirm(
        `您的极速${data.type ==='deposit'?'充值':'提款'}订单还未点击确认, 为避免${data.type ==='deposit'?'充值':'提款'}延迟, 请您尽快确认.`,
        ()=> window.location.hash = '#/report/user/getopflists?new=1&version=x',
        ()=>  this.props.$$BASE.closeConfirm(),
        '提示',
         null,
         null,
         null,
        '查看订单'
      )
    }
  }

  // 获取推送信息
  handleMessages(data) {
    const push = this.props.__PUSH.toJS();
    const user = this.props.__USER.toJS();
    // 停止推送时
    if (!push.push_status) { return; }
    // 推送状态
    window.push_useble = true;
    const result = _.isObject(data) ? data : JSON.parse(data);
    const __user = this.props.__USER.toJS();
    const __method = this.props.__METHOD.toJS();

    switch (result.module) {
      // 销售情况
      case 'lottery_data': {
        this.props.$$PUSH.setLotterySaleData(_.map(result.data, (item) => item));
      } break;
      // 开奖
      case 'issue_data': {
        this.props.$$PUSH.sysnNewHistoryCode(__method, result.data);
        this.props.$$PUSH.sysnLiveHistoryCode(result.data);
      } break;
      // 公告
      case 'notice': {
      } break;
      // 余额变动
      case 'user_balance': {
        this.props.$$PUSH.sysnUserBalance(result.data.availablebalance)
      } break;
      // 站内信
      case 'user_message': {
        this.props.$$PUSH.sysnUnreadNoticeCount(result.data.count)
      } break;
      // 中奖信息
      case 'project_draw_results': {
        window.setTimeout(function(){
          // 当停留在投注页的时候发送最近投注请求
          if (_.includes(window.location.hash, '#/lottery/')) {
            this.props.$$USER.getUserBetRecent();
          }
          const lastPrize = _.chain(result.data).filter({got_prize: true}).last().value();
          if (lastPrize) {
            this.togglePrizeTips(lastPrize);
          }
        }.bind(this), 2000)
      } break;
      // 上下级聊天
      case 'user_chat': {
        this.props.$$PUSH.sysnUnreadChatCount(result.data.data)
      } break;
       // 极速充提订单  
       case 'user_opf': {
        this.handleOrderConfirm(result.data)
      } break;
    }
  }

  // handle推送服务器错误
  handlePushError(data) {
    window.push_useble = false;
  }

  // 关闭声音
  stopSound() {
    this.props.$$BASE.closeSound();
  }

  // 默认关闭ALERT
  handleCloseAlert() {
    this.props.$$BASE.closeAlert();
  }

  // 默认关闭CONFIRM
  handleCloseConfirm() {
    this.props.$$BASE.closeConfirm();
  }

  // 执行confirm确定
  handleEnterConfirm(){
    const {params, confirm} = this.props.__BASE.toJS().modal.confirm;
    this.props.$$BASE.closeConfirm();
    this.props.$$BASE.excuter(confirm(..._.values(params)));
  }

  // 关闭拖拽FRAME
  handleCloseDragFrame() {
    this.props.$$BASE.closeDragFrame();
  }

  // 关闭小提示
  closeToast() {
    this.props.$$BASE.closeToast();
  }

  // 打开或关闭中奖提示窗口
  togglePrizeTips(prizeinfo) {
    const __base = this.props.__BASE.toJS();
    if (!__base.config.winnerNotice) {
      return;
    }
    this.setState({
      showPrizeTips: !this.state.showPrizeTips
    })
    if (prizeinfo) {
      const { lottery, issue, bonus, lotteryname } = prizeinfo;
      if (document.visibilityState == 'hidden') {
        $.notifiyDesk('中奖通知！', `恭喜您在【${lotteryname}】第【${issue}】期中，中奖：${bonus}元`);
      }else{
        this.props.$$BASE.winnerSound();
        this.setState({
          prizeinfo: prizeinfo
        })
      }
    }
  }
  // 子页面通过方法显示，隐藏嵌入式IFRAME弹窗
  toggleFrameModalByMessage(event){
    if (!_.includes(['show_modal', 'hide_modal', 'logout','in_recharge'], event.data.action)) {return}

    if(event.data.action == 'hide_modal'){
      this.props.$$BASE.closeIframeModal();
    }

    if(event.data.action == 'show_modal'){
      this.props.$$BASE.openIframeModal(event.data.url, event.data.title, event.data.width, event.data.height);
    }

    if(event.data.action == 'logout') {
      this.props.$$USER.logout();
    }

    if(event.data.action == 'in_recharge'){
      this.setState({
        frameState: 'in_recharge',
        title: event.data.title
      })
    }
  }

  // handleRechargeClick(){
  //   if(this.state.frameState == '')
  // }

  toggleVers(){
      switch($.getCookie('vers')){
          case 'hy':  // 恒耀
              this.styleFlag = 'hy-style';
              break;
          case 'zh':  // 众合
              this.styleFlag = 'zh-style';
              break;
          case 'df':  // 达福
              this.styleFlag = 'df-style';
              break;
          default:
              this.styleFlag = 'hy-style';
      }
  }

  closePopUp(){
    this.setState({
      frameState: 'select'
    })
    this.props.$$BASE.closeIframeModal();
  }

  handleRechargeClick(){
    const __base = this.props.__BASE.toJS();
    if(this.state.frameState == 'in_recharge'){
      this.refs.frame.src = DOMAIN +  __base.modal.iframe.url
      this.setState({frameState: 'select'});
    }
  }

  render() {
    const { routes } = this.props;
    const __base = this.props.__BASE.toJS();
    return (
      <div className={'full' + ' ' + this.styleFlag} >
        <ReactCSSTransitionGroup
                transitionAppear={true}
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}
                transitionAppearTimeout ={300}
                transitionName='fade'
                component='div'>
          <div id='componentContainer' className='full animation-container df_bg' >
            {
              __base.ui.display ? React.Children.map(this.props.children, (item) => item) : null
            }
          </div>
        </ReactCSSTransitionGroup>
        <ALERT
          display={__base.modal.alert.display}
          text={__base.modal.alert.text}
          callback={__base.modal.alert.callback || this.handleCloseAlert}
          delay={__base.modal.alert.delay}
          title={__base.modal.alert.title}
          buttonText={__base.modal.alert.buttonText}
          params={__base.modal.alert.params}
          className="modal-container"
        />
        <CONFIRM
          display={__base.modal.confirm.display}
          text={__base.modal.confirm.text}
          confirm={this.handleEnterConfirm}
          cancel={__base.modal.confirm.cancel || this.handleCloseConfirm}
          close={this.handleCloseConfirm}
          title={__base.modal.confirm.title} 
          params={__base.modal.confirm.params} 
          extendButtons={__base.modal.confirm.extendButtons}
          confirmBtnText={__base.modal.confirm.confirmBtnText}
          className="modal-container"
        />
        <SUPER_AUDIO
          notice={__base.config.soundNotice} 
          play={__base.sound.play}
          mp3={__base.sound.mp3}
          wav={__base.sound.wav}
          times={__base.sound.times}
          stopFn={this.stopSound}
        />
        <DRAG_FRAME
          display={__base.dragFrame.display}
          url={__base.dragFrame.url}
          onHide={this.handleCloseDragFrame}
        />
        <TOAST
          display={__base.toast.display}
          message={__base.toast.message}
          closeFn={this.closeToast}
          className={__base.toast.className}
        />
        <OVERLAY display={__base.modal.overlay.display} />
        <LOADING display={__base.modal.loading.display} text={__base.modal.loading.text} />
        <TransferMoney 
          platform={__base.modal.transfer.platform} 
          display={__base.modal.transfer.display}
          url={__base.modal.transfer.url}
        />
        <PrizeTips display={this.state.showPrizeTips} closeFn={this.togglePrizeTips.bind(this)} prizeinfo={this.state.prizeinfo} />
        {
          // IFRAME 嵌套框
          __base.modal.iframe.display ? 
          <Popup width={ __base.modal.iframe.width} height={ __base.modal.iframe.height} display={true} onclose={this.props.$$BASE.closeIframeModal}>
            <div className='modal-title'>
              {
                this.state.frameState == 'in_recharge' && 
                <a className="backIcon" onClick={this.handleRechargeClick.bind(this)} ></a>
              }
              {this.state.frameState == 'select' ? __base.modal.iframe.text : this.state.title}
            </div>
            <div className="iframeBox">
              <iframe ref="frame" width={ __base.modal.iframe.width} height={ __base.modal.iframe.height - 40} src={DOMAIN +  __base.modal.iframe.url} />
            </div>
          </Popup>
          : null
        }
      </div>
    );
  }
}

reactMixin(Framework.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __PUSH: state.push,
    __USER: state.user,
    __METHOD: state.method,
    __COMMON: state.common
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$USER: bindActionCreators(userAction, dispatch),
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch),
    $$PUSH: bindActionCreators(pushAction, dispatch),
    $$COMMON: bindActionCreators(commonAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Framework)